module.exports = __webpack_public_path__ + "img/testimonial-1.f392b5c3.png";